import './../scss/styles.scss';

import './lib/templates.js';
import './lib/main.js';
import $ from "jquery";
import {openModal} from "./lib/modals";

export function showRegisterModal() {
    $('.overlay').hide();
    openModal('register-modal');
}
